

export const cycleCountData = {
    zoneDropDown: [
        { value: 'Zone-1', label: 'Zone-1' },
        { value: 'Zone-3', label: 'Zone-3' },
        { value: 'Zone-5', label: 'Zone-5' },
        { value: 'Zone-7', label: 'Zone-7' },
        { value: 'Zone-11', label: 'Zone-11' }
    ],
    locationType: [
        { value: 'Primary', label: 'Primary' },
        { value: 'Secondary', label: 'Secondary' },
        { value: 'Forward Pick', label: 'Forward Pick' },
        { value: 'Overstock', label: 'Overstock' }
    ],
    operator: [
        { value: 'equalTo', label: '=' },
        { value: 'between', label: 'Between' }
    ],
    value_from:[
        { value: 'A1-P1', label: 'A1-P1' },
        { value: 'A1-P5', label: 'A1-P5' },
        { value: 'A1-P3', label: 'A1-P3' },
        { value: 'A1-P8', label: 'A1-P8' },
        { value: 'A1-P2', label: 'A1-P2' },
    ],
    value_to:[
        { value: 'A1-P1', label: 'A1-P1' },
        { value: 'A1-P5', label: 'A1-P5' },
        { value: 'A1-P3', label: 'A1-P3' },
        { value: 'A1-P8', label: 'A1-P8' },
        { value: 'A1-P2', label: 'A1-P2' },
    ]

}
